import React, { useState, useRef} from "react";

import {BackHandler, View, Text, TextInput}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import {estilos} from '../util/estilos'

import * as util from '../util/util'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import { useFocusEffect } from '@react-navigation/native';

import Botao from '../componentes/Botao'

import {semDados} from '../componentes/SemDados'

import {buscarCategorias, removerCategoria, novaCategoria as wsNovaCategoria} from '../ws/ws_categorias'

import {carregamento} from '../componentes/Carregamento'

import {ITEM_TIPO_PRODUTO, ITEM_TIPO_SERVICO, MSG_ERRO_PADRAO, TELA_PRINCIPAL} from '../util/constantes'

import cores from '../util/cores'

import RotuloErro from '../componentes/RotuloErro'

import * as texto from '../util/texto'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'

import Combo from '../componentes/Combo'

import Alerta from '../componentes/Alerta'



export default function TelaCategorias(){
   
   
	const navegacao = new useNavigation();
	
	const [sincronizando, setSincronizando] = useState(true) 
	
	const [tipo, setTipo] = useState(ITEM_TIPO_PRODUTO)
	
	const [novaNome, setNovaNome] = useState(null)
	const [novaTipo, setNovaTipo] = useState(null)
	const [novaTags, setNovaTags] = useState(null)
	const [msgErro, setMsgErro] = useState(null)

	const [lista, setLista] = useState([])
	
	const [criando, setCriando] = useState(false)
	
	const btSalvarRef = useRef();
	
	const dadosTipos = [{'id': ITEM_TIPO_PRODUTO, 'nome': "Produto"}, 
						{'id': ITEM_TIPO_SERVICO, 'nome': "Serviço"}];	


	const voltar = () => {
		navegacao.replace(util.processaVoltar())
		return true
	};


	useFocusEffect(React.useCallback(() => {

		util.print("TelaCategorias");
		
		BackHandler.addEventListener('hardwareBackPress', voltar);

		buscarDados();

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	
	}, []));
	
	
	const buscarDados= async ()=>{

		setSincronizando(true);
		
		let aux = await buscarCategorias(tipo);
		
		setLista(util.temConteudo(aux)?aux:[])
			
		setSincronizando(false)
	}


	const preparaParaExcluir= async (item)=>{
	
		util.print("preparaParaExcluir "+item.id);
		
		Alerta("Exclusão de Categoria" , "Deseja realmente excluir esta categoria?", async () => excluir(item.id));
	}
	
	
	const excluir= async (id_excluir)=>{
	
		util.print("excluir "+id_excluir);
		
		setSincronizando(true);
		
		await removerCategoria(id_excluir);
		
		buscarDados();
	}


	const novaCategoria= ()=>{
	
		util.print("novaCategoria");
		
		setNovaNome(null);
		setNovaTipo(ITEM_TIPO_PRODUTO);
		setNovaTags(null);
		
		setCriando(true);
	}


	async function salvar(){
		
		btSalvarRef.current.setCarregando(true)
        
		setMsgErro(null);
	
		if(novaTipo ==null){

            salvarErro("Selecione o tipo da categoria.");
            return;
        } 
		
		if(texto.isBlanck(novaNome)){

            salvarErro("Informe o nome da categoria.");
            return;
        }
		
		let aux  = await wsNovaCategoria(novaTipo, novaNome, novaTags);
		
		if(aux == null || aux.id ==null){
                
			salvarErro(MSG_ERRO_PADRAO);
            return; 
        }

		btSalvarRef.current.setCarregando(false)
        
		setCriando(false);
		
		buscarDados();
    }


	function salvarErro(mensagem){
		
        btSalvarRef.current.setCarregando(false);
		setMsgErro(mensagem);
    }


	function formularioPesquisa(){
		
		return (
			<View style={{flex:1}}>  
				<Bloco>   
					<View style={{marginTop:10}}/>	
					
					<Combo 
						mostrarVazio = {false}
						rotulo="Tipo:"
						dados={dadosTipos} 
						aoMudar={(valor)=>setTipo(valor.id)}
						selecionado={tipo}/>

					<View style={{marginTop:10}}/>
					
					<View style={{alignItems:'center'}}>
						<Botao 
							acao={()=>buscarDados()}
							texto="Carregar Categorias"/>    
					</View>
				</Bloco>
						
				<View style={{alignItems:'center'}}>
					<Botao 
						acao={()=>novaCategoria()}
						texto="Nova Categoria"/> 
					<View style={{marginTop:10}}/>	
				</View>
						
				{(util.temConteudo(lista))?
					(lista.map((item, index) => itemLista(item, index))):
					(<Bloco todaArea={true}> 
						<View style={{marginTop:10}}/>
							{semDados("info", "Nenhuma categoria adicionada.", 60)}
						<View style={{marginTop:10}}/>	
					</Bloco>)
				}					
			</View>	
		)
	}


	function itemLista(item, index){
		
		return (
			<Bloco key={index}> 
				<View style={{marginTop:10}}/>  
				<Text style={estilos.rotulo_titulo}>{item.nome}</Text>
				{util.temConteudo(item.tags) && <Text style={estilos.rotulo_padrao}>{item.tags}</Text>}
				<View style={{marginTop:10}}/>
				{item.padrao ==null || item.padrao<=0 &&
					<View style={{alignItems:'flex-end'}}>
						<Botao
							acao={()=>preparaParaExcluir(item)}
							texto="Excluir"
							somente_texto={true}
							cor={cores.vermelho}/> 
					</View>
				}
				<View style={{marginTop:5}}/>
			</Bloco>)
	}


	function formularioCriando(){
		
		return (
			<Bloco todaArea={true}>  
				<View style={{marginTop:20}}/>	
				
				<Combo 
					mostrarVazio = {false}
					rotulo="Selecione o Tipo:"
					dados={dadosTipos} 
					aoMudar={(valor)=>setNovaTipo(valor.id)}
					selecionado={novaTipo}/>
				
				<View style={{marginTop:30}}/> 
								
				<Text style={estilos.rotulo_padrao}>Nome:</Text>
							
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>setNovaNome(text)}
					maxLength={150}
					value={novaNome}/>
				
				<View style={{marginTop:30}}/> 
								
				<Text style={estilos.rotulo_padrao}>Tags (opcional):</Text>
							
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>setNovaTags(text)}
					maxLength={150}
					value={novaTags}/>
				
				<View style={{marginTop:30}}/> 

				<View style={{alignItems:'center'}}>
					<RotuloErro mensagem={msgErro}/>
				</View>
				
				<View style={{marginTop:30}}/>
				
				<View style={{alignItems:'center'}}>
					<Botao 
						acao={()=>salvar()}
						texto="Salvar"
						ref={btSalvarRef}/>    
				</View>
			</Bloco>
		)
	}


	return (
		<ViewDegradeVertical titulo="Categorias" voltar={()=>voltar()}>
			{(sincronizando) ?
				(carregamento(sincronizando)):
				(<Scroll> 	
					{(criando)?
						(formularioCriando()):
						(formularioPesquisa())
					}	
				</Scroll>)
			}
		</ViewDegradeVertical>	
	);
}

